import React from 'react';

type SpriteIconProps = {
  name: string;
  size?: {height: number, width: number};
  className?: string;
  id?: string;
  fill?: string;
  onClick?: (e: React.MouseEvent<HTMLOrSVGElement>)=> void
};

const DEFAULT_ICON_SIZE = 24;

const SpriteIcon = ({
    name,
    size = {height: DEFAULT_ICON_SIZE, width: DEFAULT_ICON_SIZE},
    className = '', id = '', fill = '', onClick
}: SpriteIconProps): JSX.Element => <svg
    width={size.width}
    height={size.height}
    className={className}
    aria-hidden="true"
    onClick={onClick}
>
    <use href={`/sprite.svg${name}`} id={id} fill={fill}/>
</svg>;
export default SpriteIcon;
